import { createFileRoute } from "@tanstack/react-router";
import { getBlogSocialImageUrl } from "src/lib/BlogPosts";
import { metadataHead } from "src/lib/Metadata";
import { InlineRouteErrorPage } from "src/routes/-components/RouteBoundaries";
import { getBlogPostPage } from "src/server/functions/Blog";

// A post is a server component (src/server/functions/Blog.tsx); it changes only with a deploy.
export const Route = createFileRoute("/blog/$slug")({
  loader: ({ params }) => getBlogPostPage({ data: params.slug }),
  staleTime: Number.POSITIVE_INFINITY,
  head: ({ loaderData }) => {
    if (!loaderData) return {};
    const { post } = loaderData;
    const canonicalPath = `/blog/${post.slug}`;
    const image = {
      url: getBlogSocialImageUrl(post.slug),
      width: 1200,
      height: 630,
      alt: post.title,
    };
    return metadataHead({
      title: post.title,
      description: post.description,
      alternates: { canonical: canonicalPath },
      openGraph: {
        type: "article",
        url: canonicalPath,
        title: post.title,
        description: post.description,
        publishedTime: new Date(post.date).toISOString(),
        images: [image],
      },
      twitter: {
        card: "summary_large_image",
        title: post.title,
        description: post.description,
        images: [image],
      },
    });
  },
  component: BlogPostPage,
  // Inside the blog layout's header and footer (the router's default error page has its own).
  errorComponent: InlineRouteErrorPage,
});

function BlogPostPage() {
  const { post, content } = Route.useLoaderData();
  return (
    <>
      {/* One `article:tag` per tag. The route `head` keeps a single tag per property, so these are
          rendered here; React hoists them into the document head. */}
      {post.tags.map((tag) => (
        <meta key={tag} property="article:tag" content={tag} />
      ))}
      {content}
    </>
  );
}
